/**
 * The live Metabase instance. Hardcoded rather than env-driven: there is only
 * ever one instance, and having it configurable is how the codebase ended up
 * with the API routes pointing at this namespace while the embed component
 * defaulted to a since-retired test instance ("intric-anemone").
 */
export const METABASE_NAMESPACE = "the-climate-risk-group";

export const METABASE_INSTANCE_URL = `https://${METABASE_NAMESPACE}.metabaseapp.com`;
